import { render, staticRenderFns } from "./AICaseHistory.vue?vue&type=template&id=cc252392&scoped=true&"
import script from "./AICaseHistory.vue?vue&type=script&lang=js&"
export * from "./AICaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./AICaseHistory.vue?vue&type=style&index=0&id=cc252392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc252392",
  null
  
)

export default component.exports